import { Component, OnInit } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';

@Component({
  selector: 'launcher',
  templateUrl: './launcher.component.html',
  styleUrls: ['./launcher.component.scss']
})
export class LauncherComponent implements OnInit {

  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // 
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
  }

  

}
